import { render } from "./HeaderComp.vue?vue&type=template&id=7e1c7451&scoped=true&ts=true"
import script from "./HeaderComp.vue?vue&type=script&lang=ts"
export * from "./HeaderComp.vue?vue&type=script&lang=ts"

import "./HeaderComp.vue?vue&type=style&index=0&id=7e1c7451&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1c7451"]])

export default __exports__